module.exports = __webpack_public_path__ + "static/media/Apr9-S18.e5e22cec.png";